import { UserFormValues } from '../model/userFormSchema'

export function timeToIso(time: string): string {
  if (time.includes('T')) return time
  return `2025-01-01T${time}:00.000Z`
}

export function prepareTechnicianProfileForApi(data: UserFormValues) {
  if (!data.roles.includes('WORKER') || !data.technicianProfile) return data

  return {
    ...data,
    technicianProfile: {
      ...data.technicianProfile,
      shiftStart: timeToIso(data.technicianProfile.shiftStart),
      shiftEnd: timeToIso(data.technicianProfile.shiftEnd),
      breakStart: timeToIso(data.technicianProfile.breakStart),
    },
  }
}
